"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// export interface IUserProps {
//   [key: string]: number
// }
//
// export interface IUserItems {
//   [key: string]: number
// }
